var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatVet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.33196 2 4.97501V20.0064C2 20.9438 3.19036 21.3578 3.78087 20.6259L6 17.975H19C20.6569 17.975 22 16.6431 22 15V4.97501C22 3.33196 20.6569 2 19 2H5ZM16 13.8793C16 15.3118 15.1059 15.0765 13.9156 14.7632C13.3256 14.608 12.6628 14.4335 12 14.4335C11.3372 14.4335 10.6744 14.608 10.0844 14.7632C8.89406 15.0765 8 15.3118 8 13.8793C8 11.7368 9.79086 10 12 10C14.2091 10 16 11.7368 16 13.8793ZM12 9C11.1716 9 10.5 8.10457 10.5 7C10.5 5.89543 11.1716 5 12 5C12.8284 5 13.5 5.89543 13.5 7C13.5 8.10457 12.8284 9 12 9ZM8.99807 7.24963C9.55035 8.20621 9.41647 9.31747 8.69903 9.73168C7.98159 10.1459 6.95228 9.70621 6.39999 8.74963C5.84771 7.79304 5.98159 6.68179 6.69903 6.26758C7.41647 5.85336 8.44579 6.29304 8.99807 7.24963ZM15.299 9.73168C14.5816 9.31747 14.4477 8.20621 15 7.24963C15.5523 6.29304 16.5816 5.85336 17.299 6.26758C18.0165 6.68179 18.1504 7.79304 17.5981 8.74963C17.0458 9.70621 16.0165 10.1459 15.299 9.73168Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatVet);
export default __webpack_public_path__ + "static/media/chat-vet.1333a251327737b7f6918a9009c2dc1e.svg";
export { ForwardRef as ReactComponent };